import _classCallCheck from "/Users/maximilian/Projekte/DevCloud/Apps/panel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import localStorage from "./lib/LocalStorage";

var Storage = function Storage() {
  _classCallCheck(this, Storage);

  if (window.localStorage) {
    return localStorage;
  } else {
    throw "Local Storage not supported!";
  }
};

export { Storage as default };